<!--动态图对象 右键属性-->
<template>
  <div class="countbook">
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-计算模块' : '新建' + '-计算模块'"
      :has-form="true"
      :show-footer="false"
      class="object-transfer-dialog-modal"
      width="50%"
      top="100px"
      @close="close"
      @confirm="handleConfirm"
    >
      <div style="height: 500px">
        <gs-form
          :model="form"
          label-width="95px"
          label-position="left"
          gap="small"
        >
          <gs-form-item label="名称" prop="target" class="form-item-radio">
            <gs-input ref="nameInput" v-model="name" />
          </gs-form-item>
          <gs-form-item label="描述" prop="target" class="form-item-radio">
            <gs-input ref="nameInput" v-model="description" />
          </gs-form-item>
          <gs-form-item label="计算类型" prop="target" class="form-item-radio">
            <el-radio v-model="formData.calculationEnum" label="NUMERICAL"
              >数值计算</el-radio
            >
            <el-radio v-model="formData.calculationEnum" label="LOGICAL"
              >逻辑运算</el-radio
            >
            <el-radio v-model="formData.calculationEnum" label="BIT"
              >位运算</el-radio
            >
            <el-radio v-model="formData.calculationEnum" label="ASSIGNMENT"
              >赋值计算</el-radio
            >
          </gs-form-item>
          <div class="content-main">
            <div
              class="content-tab"
              v-if="formData.calculationEnum == 'NUMERICAL'"
            >
              <gs-form-item label="状态" prop="minChange">
                <el-switch
                  v-model="formData.status"
                  active-color="#409EFF"
                  inactive-color="#585858"
                >
                </el-switch>
              </gs-form-item>
              <gs-form-item
                label="计算公式"
                prop="target"
                class="form-item-radio"
              >
                <gs-input
                  ref="nameInput"
                  v-model="form.formula"
                  @change="operatingNumber"
                  @input="operatingNumber"
                />
              </gs-form-item>
              <div>
                <span style="font-size: 10px">点位选取</span>
                <div class="form-item-objectSeries">
                  <gs-table
                    v-if="visible"
                    ref="objTable"
                    :data="form.objectSeries"
                    @select="selectData"
                    @select-all="selectData"
                  >
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="countName"
                      label="参数"
                      width="30"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="name"
                      label="对应数据"
                      data-align="right"
                      width="30"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="address"
                      label="位置"
                      data-align="right"
                      width="60"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="type"
                      label=""
                      width="20"
                    >
                      <template slot-scope="scope">
                        <!--<gs-button @click="add(scope.row)">添加</gs-button>-->
                        <i
                          class="el-icon-circle-plus-outline"
                          @click="add(scope.row)"
                        ></i>
                      </template>
                    </gs-table-column>
                  </gs-table>
                </div>
              </div>
            </div>
            <div
              class="content-tab"
              v-if="formData.calculationEnum == 'LOGICAL'"
            >
              <gs-form-item label="状态" prop="minChange">
                <el-switch
                  v-model="formData.status"
                  active-color="#409EFF"
                  inactive-color="#585858"
                >
                </el-switch>
              </gs-form-item>
              <el-row
                :gutter="10"
                style="margin-top: 10px; width: 100%"
                v-for="(v, index) in ruleForms"
                :key="index"
              >
                <el-col :span="2">
                  <span style="font-size: 12px">条件:</span>
                </el-col>
                <el-col :span="3">
                  <el-input
                    size="mini"
                    v-model="v.a"
                    placeholder=""
                    @change="operatingNumber"
                    @input="operatingNumber"
                  ></el-input>
                </el-col>
                <el-col :span="4">
                  <gs-select
                    size="mini"
                    v-model="v.valueOne"
                    style="width: 100%"
                  >
                    <gs-option
                      v-for="item in timeArrayOne"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </gs-option>
                  </gs-select>
                </el-col>
                <el-col :span="3">
                  <el-input
                    size="mini"
                    v-model="v.b"
                    placeholder=""
                    @change="operatingNumber"
                    @input="operatingNumber"
                  ></el-input>
                </el-col>
                <el-col :span="2">
                  <i
                    class="el-icon-circle-plus-outline"
                    v-if="index == 0"
                    @click="addLogIf"
                  ></i>
                  <i
                    class="el-icon-remove-outline"
                    v-if="index != 0"
                    @click="dellLogIf(index)"
                  ></i>
                </el-col>
              </el-row>
              <el-row
                style="margin-top: 10px"
                v-for="(n, index) in outputValue"
                :key="'info-' + index"
              >
                <el-col :span="2">
                  <span style="font-size: 12px">输出：</span>
                </el-col>
                <el-col :span="2">
                  <el-input
                    size="mini"
                    v-model="n.point"
                    placeholder=""
                    @change="operatingNumber"
                    @input="operatingNumber"
                  ></el-input>
                </el-col>
                <el-col :span="3" :offset="2">
                  <span style="font-size: 12px">输出值：</span>
                </el-col>
                <el-col :span="2">
                  <el-input
                    size="mini"
                    v-model="n.value"
                    placeholder=""
                  ></el-input>
                </el-col>
                <el-col :span="2" :offset="1">
                  <i
                    class="el-icon-circle-plus-outline"
                    @click="addValueIf"
                    v-if="index == 0"
                  ></i>
                  <i
                    class="el-icon-remove-outline"
                    v-if="index != 0"
                    @click="dellValueIf(index)"
                  ></i>
                </el-col>
              </el-row>
              <div style="width: 100%; height: 100px; margin-top: 10px">
                <div class="form-item-objectSeries">
                  <gs-table
                    v-if="visible"
                    ref="objTable"
                    :data="form.objectSeries"
                    @select="selectData"
                    @select-all="selectData"
                  >
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="countName"
                      label="参数"
                      width="30"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="name"
                      label="对应数据"
                      data-align="right"
                      width="30"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="address"
                      label="位置"
                      data-align="right"
                      width="60"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="type"
                      label=""
                      width="20"
                    >
                      <template slot-scope="scope">
                        <!--<gs-button @click="add(scope.row)">添加</gs-button>-->
                        <i
                          class="el-icon-circle-plus-outline"
                          @click="add(scope.row)"
                        ></i>
                      </template>
                    </gs-table-column>
                  </gs-table>
                </div>
              </div>
            </div>
            <div class="content-tab" v-if="formData.calculationEnum == 'BIT'">
              <gs-form-item label="状态" prop="minChange">
                <el-switch
                  v-model="formData.status"
                  active-color="#409EFF"
                  inactive-color="#585858"
                >
                </el-switch>
              </gs-form-item>
              <!-- <el-row :gutter="30" style="width: 100%">
                <el-col :span="3">
                  <span>条件：</span>
                </el-col>
                <el-col :span="6">
                  <el-input
                    size="mini"
                    v-model="bitOperationArr.a"
                    placeholder="请输入内容"
                    @change="operatingNumber"
                    @input="operatingNumber"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <gs-select
                    v-model="bitOperationArr.valueOne"
                    style="width: 100%"
                  >
                    <gs-option
                      v-for="item in timeArrayTwo"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </gs-option>
                  </gs-select>
                </el-col>
                <el-col :span="6">
                  <el-input
                    size="mini"
                    v-model="bitOperationArr.b"
                    placeholder="请输入内容"
                    @change="operatingNumber"
                    @input="operatingNumber"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row
                :gutter="30"
                style="width: 100%; margin-top: 10px"
                v-for="(n, index) in bitOperationValArr"
                :key="'inten-' + index"
              >
                <el-col :span="3">
                  <span>结果：</span>
                </el-col>
                <el-col :span="6">
                  <el-input
                    size="mini"
                    v-model="n.point"
                    placeholder="请输入内容"
                    @change="operatingNumber"
                    @input="operatingNumber"
                  ></el-input>
                </el-col>
                <el-col :span="3">
                  <i
                    class="el-icon-circle-plus-outline"
                    v-if="index == 0"
                    @click="addLogIfBitValue"
                  ></i>
                  <i
                    class="el-icon-remove-outline"
                    v-if="index != 0"
                    @click="dellLogIfBitValue(index)"
                  ></i>
                </el-col>
              </el-row> -->

              <gs-form-item label="计算公式" prop="minChange">
                <gs-input
                  v-model="form.formula"
                  @change="operatingNumber"
                  @input="operatingNumber"
                  placeholder="请输入位运算公式，如：!(a&b)=c"
                ></gs-input>
                <span style="font-size: 12px; color: #999"
                  >&（与）、|（或）、！（非）、#（与非）、
                  @（或非）、~（同或）、$（异或）</span
                >
              </gs-form-item>
              <div style="width: 100%; height: 100px; margin-top: 10px">
                <div class="form-item-objectSeries">
                  <gs-table
                    v-if="visible"
                    ref="objTable"
                    :data="form.objectSeries"
                    @select="selectData"
                    @select-all="selectData"
                  >
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="countName"
                      label="参数"
                      width="30"
                    />
                    <!-- <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="name"
                      label="对应数据"
                      data-align="right"
                      width="30"
                    /> -->
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="address"
                      label="位置"
                      data-align="right"
                      width="60"
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="type"
                      label=""
                      width="20"
                    >
                      <template slot-scope="scope">
                        <!--<gs-button @click="add(scope.row)">添加</gs-button>-->
                        <i
                          class="el-icon-circle-plus-outline"
                          @click="add(scope.row)"
                        ></i>
                      </template>
                    </gs-table-column>
                  </gs-table>
                </div>
              </div>
            </div>
            <div
              class="content-tab"
              v-if="formData.calculationEnum == 'ASSIGNMENT'"
            >
              <!-- <gs-form-item label="开始时间" prop="startTime">
                <gs-date-picker v-model="formData.startTime" :default-time="defaultTime" type="date-time"
                  input-type="input" value-format="yyyy-MM-dd HH:mm:ss" />
                <el-date-picker v-model="formData.startTime" type="datetime" placeholder="选择日期时间" >
                </el-date-picker>
              </gs-form-item> -->

              <gs-form-item label="状态" prop="minChange">
                <el-switch
                  v-model="formData.status"
                  active-color="#409EFF"
                  inactive-color="#585858"
                >
                </el-switch>
              </gs-form-item>
              <gs-form-item label="关联">
                <gs-select
                  v-model="formData.linkage"
                  class="doc-select"
                  @change="changeLinkage"
                >
                  <gs-option
                    v-for="item in activateOptionsLian"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </gs-select>
              </gs-form-item>
              <gs-form-item
                label="延迟时间"
                prop="updateInterval"
                v-if="linkageShow"
              >
                <el-row>
                  <el-col :span="3">
                    <gs-input v-model="formData.delayTime" />
                  </el-col>
                  <el-col :span="2">
                    <label style="font-size: 16px">&nbsp;ms</label>
                  </el-col>
                </el-row>
              </gs-form-item>
              <gs-form-item label="最小变化" prop="minChange">
                <gs-input
                  v-model="formData.differenceValue"
                  style="width: 60px"
                />
              </gs-form-item>
              <!-- <gs-form-item label="激活">
                <gs-select v-model="formData.status" class="doc-select">
                  <gs-option v-for="item in activateOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </gs-select>
              </gs-form-item> -->
              <gs-form-item
                label="是否开启单项传递"
                label-width="130px"
                v-show="linkageShow"
              >
                <el-switch
                  v-model="formData.oneWay"
                  active-color="#409EFF"
                  inactive-color="#585858"
                >
                </el-switch>
              </gs-form-item>
              <gs-form-item
                label="单项传递的值"
                label-width="130px"
                v-if="linkageShow"
              >
                <gs-input v-model="formData.oneWayValue" style="width: 84%" />
              </gs-form-item>
              <fieldset>
                <legend>传输源</legend>
                <gs-form-item label="对象" prop="fromObject" label-width="50px">
                  <gs-input
                    v-model="showFromObject"
                    :disabled="showFromObject === ''"
                    style="width: 84%"
                  />
                  <gs-button @click="addObject('fromObject')">...</gs-button>
                </gs-form-item>
              </fieldset>
              <fieldset>
                <legend>传输目标</legend>
                <gs-form-item label="对象" prop="toObject" label-width="50px">
                  <gs-input v-model="showToObject" style="width: 84%" />
                  <gs-button @click="addObject('toObject')">...</gs-button>
                </gs-form-item>
              </fieldset>
            </div>
          </div>
          <div class="button">
            <gs-form-item>
              <gs-button type="primary" @click="handleConfirm(1)"
                >确定</gs-button
              >
              <gs-button @click="close">取消</gs-button>
              <gs-button @click="dialogHelp = true">帮助</gs-button>
            </gs-form-item>
          </div>
        </gs-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm"
          >确 定</gs-button
        >
        <gs-button type="primary" size="mini" @click="beforeClose"
          >取 消</gs-button
        >
        <gs-button type="primary" size="mini">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal
      v-model="visibleAdd"
      :before-close="beforeCloseAdd"
      class="my-test-class"
      title="添加"
      @close="closeAdd"
      @confirm="handleConfirmAdd"
      top="100px"
    >
      <gs-tree
        v-if="visibleAdd"
        ref="tree"
        :data="addList"
        :props="props"
        :disable-node="true"
        :leaf-checkbox-only="true"
        :node-key="'id'"
        show-checkbox
        @check-change="checkEvent"
      />
    </gs-modal>
    <gs-modal
      title="帮助"
      v-model="dialogHelp"
      width="30%"
      class="my-test-class"
      :before-close="handleCloseHelp"
    >
      <span>1. 数值计算、逻辑计算、三元运算为一个整体，三角函数为一个整体</span
      ><br />
      <span
        >2. 数值计算、逻辑计算、三元运算统统使用小写英文字母进行公式的书写如(
        a+b*c )，而三角函数小写代表符号大写代表值如( cos(A)+sin(B) )</span
      >
      <span slot="footer" class="dialog-footer">
        <!--<el-button @click="dialogHelp = false">取 消</el-button>
            <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>
    <gs-modal
      v-model="visibleAdds"
      :title="'添加' + addTitle"
      class="alarmReceiver-select"
      @close="closeAdd"
      @confirm="handleConfirmAdds"
      top="100px"
    >
      <div class="treeList">
        <gs-tree
          @node-click="treeClick"
          v-if="visibleAdds"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
          @check-change="checkEvent"
        />
      </div>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from "vuex";
import moment from "moment";
import service from "../../service/leftService.js";
import eventBus from "../timeChart/vue.js";
export default {
  components: {},
  data() {
    return {
      linkageShow: true,
      fuStatus: true, // 状态
      addorshow: false,
      timeShow: "",
      disabled: false,
      // 位运算
      bitOperationArr: { a: "", valueOne: "", b: "" },
      bitOperationValArr: [{ point: "" }],
      // 逻辑运算
      ruleForms: [{ a: "", b: "", valueOne: "" }],
      outputValue: [{ point: "", value: "" }],
      logicnumber: {
        a: "",
        b: "",
        c: "",
        d: "",
        e: "",
        value: "",
      },
      addTitle: "",
      defaultTime: moment(),
      dataList: [],
      visibleAdds: false,
      // 结构参数
      formData: {
        outputValue: [],
        fromObject: "",
        toObject: "",
        calculationEnum: "NUMERICAL",
        calculateType: "",
        result: [],
        realTimeValue: [],
        notRealTimeValue: [],
        formula: "",
        formulaMap: {},
        source: "",
        status: true,
        //startTime: moment(),
        delayTime: "100",
        differenceValue: 0.0,
        operatorList: [],
        linkage: 2,
        writeResultMap: {},
        objectSeries: [],
        oneWay: false,
        oneWayValue: 1,
      },
      minChange: "",
      updateInterval: "",
      startTime: "",
      activate: "",
      showFromObject: "",
      showToObject: "",
      test: "",
      timeArrayOne: [
        {
          value: ">",
          label: ">",
        },
        {
          value: "<",
          label: "<",
        },
        {
          value: "=",
          label: "=",
        },
        {
          value: ">=",
          label: ">=",
        },
        {
          value: "<=",
          label: "<=",
        },
      ],
      timeArrayTwo: [
        {
          value: "&",
          label: "&",
        },
        {
          value: "|",
          label: "|",
        },
        {
          value: "~",
          label: "~",
        },
        {
          value: "^",
          label: "^",
        },
      ],
      timeArrayThree: [
        {
          value: ">",
          label: ">",
        },
        {
          value: "<",
          label: "<",
        },
        {
          value: "=",
          label: "=",
        },
        {
          value: "|",
          label: "|",
        },
        {
          value: "?",
          label: "?",
        },
      ],
      valueOne: "",
      valueTwo: "",
      valueThree: "",
      tableData: [],
      activateOptions: [
        {
          value: false,
          label: "关闭",
        },
        {
          value: true,
          label: "开启",
        },
      ],
      activateOptionsLian: [
        {
          value: 1,
          label: "联动",
        },
        {
          value: 2,
          label: "独立",
        },
        {
          value: 3,
          label: "点动",
        },
      ],
      dialogHelp: false,
      radio: "numerical_calculation",
      objectInfo: {},
      loading: false,
      activeName: "first",
      form: {
        objectSeries: [],
        primaryY_autoScale: true,
        primaryY_Mininum: 0,
        primaryY_maximum: 100,
        secondaryY_autoScale: true,
        secondaryY_Mininum: 0,
        secondaryY_maximum: 100,
        logInterval_value: 1,
        logInterval_unit: "s",
        maxLogNum: "",
        formula: "",
        formulaMode: "numerical_calculation",
        fromObject: null,
        fromProperty: "value",
        toObject: null,
        toProperty: "value",
        triggingObject: null,
        // startTime: moment(),
        activate: "",
        transferPeriod: null,
        minChange: 0,
        updateInterval: null,
      },
      description: "",
      checked: "",
      options: [
        {
          label: "秒(s)",
          value: "s",
        },
        {
          label: "分(m)",
          value: "m",
        },
        {
          label: "时(h)",
          value: "h",
        },
        {
          label: "天(d)",
          value: "d",
        },
      ],
      visibleAdd: false,
      visibleProperties: false,
      addList: [],
      props: {
        label: "name",
        disabled: "type:folder",
      },
      selectList: [],
      name: "",
      showList: [],
      row: "",
      isEdit: false,
      oldData: {},
      selectOrg: {
        orgsid: [],
      },
      tableObj: {},
      huiXian: false,
    };
  },
  computed: {
    ...mapState({
      visible: "countBookShow",
      nodeData: "objectInfo",
    }),
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData;
    },
    nodeData() {},
    visible() {
      if (this.visible) {
        this.objectInfo = JSON.parse(JSON.stringify(this.nodeData));
        console.log(this.objectInfo);
        if (
          JSON.stringify(this.objectInfo) !== "{}" &&
          this.objectInfo.type == "calculation"
        ) {
          this.huixian = true;
          this.addorshow = true;
          // 点击属性时进行回显操作
          /*   this.formData = {
              calculationEnum: 'NUMERICAL',
              calculateType: '',
              result: [],
              realTimeValue: [],
              notRealTimeValue: [],
              formula: '',
              formulaMap: {},
              source: '',
              status: true,
              startTime: moment(),
              delayTime: '100',
              differenceValue: 0.00,
              operatorList: [],
              linkage: false,
              writeResultMap: {},
              objectSeries: [],
            }
            this.isEdit = true
            this.activeName = 'first'
            this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {}
            this.description = this.objectInfo.description ? this.objectInfo.description : ''
            this.name = this.objectInfo.name ? this.objectInfo.name : ''
            this.form.objectSeries = this.objectInfo.attribute.objectSeries ? JSON.parse(JSON.stringify(this.objectInfo.attribute.objectSeries)) : [] */
          this.isEdit = true;
          this.form.objectSeries = [];
          if (this.objectInfo.attribute.calculationEnum == "NUMERICAL") {
            this.formData.calculationEnum = "NUMERICAL";
            this.formData.calculateType = "NUMERICAL";
            this.formData = this.objectInfo.attribute;
            this.form.formula = this.objectInfo.attribute.formula;
            this.form.objectSeries = this.objectInfo.attribute.objectSeries;
          } else if (this.objectInfo.attribute.calculationEnum == "LOGICAL") {
            this.formData = this.objectInfo.attribute;
            this.formData.calculationEnum = "LOGICAL";
            this.formData.calculateType = "LOGICAL";
            this.ruleForms = [];
            this.form.objectSeries = this.objectInfo.attribute.objectSeries;
            this.outputValue = this.objectInfo.attribute.outputValue;
            this.objectInfo.attribute.operatorList.forEach((item) => {
              let obj = {
                a: item[0],
                valueOne: item[1],
                b: item[2],
              };
              this.ruleForms.push(obj);
            });
          } else if (this.objectInfo.attribute.calculationEnum == "BIT") {
            this.formData.calculationEnum = "BIT";
            this.formData.calculateType = "BIT";
            this.formData = this.objectInfo.attribute;

            // 回显公式和对象系列
            this.form.formula = this.objectInfo.attribute.formula || "";
            this.form.objectSeries =
              this.objectInfo.attribute.objectSeries || [];
          } else if (
            this.objectInfo.attribute.calculationEnum == "ASSIGNMENT"
          ) {
            this.formData = this.objectInfo.attribute;
            // this.formData.startTime = moment()
            this.formData.calculationEnum = "ASSIGNMENT";
            this.formData.calculateType = "ASSIGNMENT";
            this.showFromObject = this.objectInfo.attribute.fromObject;
            this.showToObject = this.objectInfo.attribute.toObject;
            this.disabled = true;
            this.timeShow = this.timestampToYMDHMS(
              this.objectInfo.attribute.startTime
            );
          }
          this.name = this.objectInfo.name ? this.objectInfo.name : "";
          this.description = this.objectInfo.description
            ? this.objectInfo.description
            : "";
        } else {
          this.addorshow = false;
          this.disabled = false;
          // 点击新建时创建操作
          this.isEdit = false;
          this.activeName = "first";
          this.form = {
            objectSeries: [],
            primaryY_autoScale: true,
            primaryY_Mininum: 0,
            primaryY_maximum: 100,
            secondaryY_autoScale: true,
            secondaryY_Mininum: 0,
            secondaryY_maximum: 100,
            logInterval_value: 1,
            logInterval_unit: "s",
            maxLogNum: "",
          };
          this.description = "";
          this.name = "";
          this.showFromObject = "";
          this.showToObject = "";
          this.formData = {
            showFromObject: "",
            showToObject: "",
            calculationEnum: "NUMERICAL",
            calculateType: "",
            result: [],
            realTimeValue: [],
            notRealTimeValue: [],
            formula: "",
            formulaMap: {},
            source: "",
            status: true,
            //startTime: moment(),
            delayTime: "100",
            differenceValue: 0.0,
            operatorList: [],
            linkage: 2,
            writeResultMap: {},
            objectSeries: [],
            //
          };
        }
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations({
      close: "COUNT_BOOK_HIDE",
      needReload: "COUNT_BOOK_TREE",
    }),
    // 点击选择关联对象
    changeLinkage() {
      if (this.formData.linkage == 1) {
        this.linkageShow = false;
        this.formData.oneWay = false;
        this.formData.delayTime = "0";
      }
      if (this.formData.linkage == 2) {
        this.linkageShow = true;
        this.formData.oneWay = true;
        this.formData.delayTime = "100";
      }
      if (this.formData.linkage == 3) {
        this.linkageShow = false;
        this.formData.oneWay = false;
        this.formData.delayTime = "0";
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    beforeClose() {
      this.close();
      this.formData.calculationEnum = "NUMERICAL";
      this.clearValue();
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === "") {
        this.$Message.warning("名称不能为空!");
        return;
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning("Y轴最小值必须小于最大值");
          return;
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning("Y轴最小值必须小于最大值");
          return;
        }
      }
      // done(false)可以阻止modal关闭
      done();
    },
    handleConfirm() {
      if (!this.name) {
        this.$Message.warning("名称不能为空");
        return;
      }

      let _this = this;
      this.loading = true;
      // let arr = []
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries));
      /*this.form.objectSeries.forEach(e => {
        arr.push(e.id)
      })*/
      //this.form.objectSeries = arr
      if (this.objectInfo.id && this.objectInfo.type === "formulaToValue") {
        let param = {
          id: this.objectInfo.id,
          name: this.name,
          type: this.objectInfo.type,
          value: this.objectInfo.value,
          parentId: this.objectInfo.parentId,
          description: this.description,
          attribute: this.form, // 其他信息这里，键值对形式
        };
        service
          .renamePoint(param)
          .then((res) => {
            this.loading = false;
            this.$Message.success("修改成功");
            _this.objectInfo.attribute.objectSeries = backArr;
            this.close();
            this.objectInfo.name = this.name;
            res.attribute.objectSeries = backArr;
            this.$store.state.tabPanel = res;
            this.$store.state.updateTreeNode = res;
            this.description = "";
            this.name = "";
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = [];
            // eventBus.$emit('changeInterval', res)
          })
          .catch((err) => {
            this.loading = false;
            // this.form.objectSeries = backArr
            // this.$Message.error(err.message)
            console.log(err);
          });
      } else {
        if (this.formData.calculationEnum === "NUMERICAL") {
          this.numberSelect();
        }
        if (this.formData.calculationEnum === "LOGICAL") {
          this.formData.calculateType = "LOGICAL";
          this.logicalSelect();
        }
        if (this.formData.calculationEnum === "ASSIGNMENT") {
          this.formData.calculateType = "ASSIGNMENT";
          this.formData.differenceValue = this.formData.differenceValue;
          this.formData.toObject = this.showToObject;
          this.formData.fromObject = this.showFromObject;
          if (this.formData.linkage == 1) {
            this.formData.linkage = true;
          }
          if (this.formData.linkage == 2) {
            this.formData.linkage = false;
          }
          if (this.formData.linkage == 3) {
            this.formData.linkage = null;
          }
        }
        if (this.formData.calculationEnum === "BIT") {
          // 验证位运算公式
          if (!this.validateBitFormulaForSubmit()) {
            this.loading = false;
            return;
          }
          this.bitSelect();
        }

        let param = {
          name: this.name,
          type: "calculation",
          parentId: this.nodeData.id,
          description: this.description,
          attribute: this.formData, // 其他信息这里，键值对形式
        };

        if (this.objectInfo.type === "calculation") {
          param.id = this.objectInfo.id;
          param.parentId = this.objectInfo.parentId;
          service.renamePoint(param).then((res) => {
            this.loading = false;
            this.$Message.success("修改成功");

            setTimeout(() => {
              res.attribute.objectSeries = backArr;
              _this.$store.state.addTreeNode = res;
            }, 0);
            this.close();
            this.description = "";
            this.name = "";
            this.formData.result = [];
            this.formData.realTimeValue = [];
            this.formData.referenceDataPoint = [];
            this.formData.formula = "";
            this.formData.linkage = 2;
            this.formData.formulaMap = "";
            this.formData.referenceDataPoint = [];
            this.formData.source = "";
            this.formData.delayTime = "100";
            this.formData.differenceValue = 0.0;
            this.showToObject = "";
            this.showFromObject = "";
            //this.clearValue()
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = [];
          });
        } else {
          service
            .newAddPoint(param)
            .then((res) => {
              this.loading = false;
              this.$Message.success("添加成功");
              setTimeout(() => {
                res.attribute.objectSeries = backArr;
                _this.$store.state.addTreeNode = res;
              }, 0);
              this.close();
              this.description = "";
              this.name = "";
              this.formData.result = [];
              this.formData.realTimeValue = [];
              this.formData.referenceDataPoint = [];
              this.formData.formula = "";
              this.formData.linkage = 2;
              this.formData.formulaMap = "";
              this.formData.referenceDataPoint = [];
              this.formData.source = "";
              this.formData.delayTime = "100";
              this.formData.differenceValue = 0.0;
              this.showToObject = "";
              this.showFromObject = "";
              //this.clearValue()
              // this.form = {
              //   objectSeries: []
              // }
              this.showList = [];
            })
            .catch((err) => {
              this.loading = false;
              this.form.objectSeries = backArr;
              console.log(err);
              this.clearValue();
              // this.$Message.error(err.message)
            });
        }
      }
    },
    // 数值计算数据拆分
    numberSelect() {
      let obj = {};
      let str = this.form.formula.split("=")[0];
      this.formData.formula = str;
      this.formData.calculateType = "NUMERICAL";
      this.formData.objectSeries = this.form.objectSeries;
      let a = this.form.objectSeries.length - 1;
      for (let i = 0; i < a; i++) {
        obj[this.form.objectSeries[i].countName] = this.form.objectSeries[i].id;
        this.formData.realTimeValue.push(this.form.objectSeries[i].id);
      }
      // 根据ID查询自定义点位信息
      service.getNode(this.form.objectSeries[a].id).then((res) => {
        let obj = res;
        if (res.attribute.pointType) {
          obj.attribute.realTime = true;
          service.updatePointData(obj).then((res) => {
            console.info("数据修改成功");
          });
        }
      });
      // 添加数据信息
      this.formData.result.push(this.form.objectSeries[a].id);
      this.formData.formulaMap = obj;
    },
    // 位运算
    addLogIfBitValue() {
      this.bitOperationValArr.push({
        point: "",
      });
    },
    dellLogIfBitValue(index) {
      this.bitOperationValArr.splice(index, 1);
    },
    // 逻辑运算
    addLogIf() {
      this.ruleForms.push({
        a: "",
        b: "",
        valueOne: "",
      });
    },
    addValueIf() {
      this.outputValue.push({
        point: "",
        value: "",
      });
    },
    dellValueIf(index) {
      this.outputValue.splice(index, 1);
    },
    dellLogIf(index) {
      this.ruleForms.splice(index, 1);
    },
    logicalSelect() {
      /*  let a = this.form.objectSeries.length - 1
       let strOne = this.logicnumber.a + this.valueOne + this.logicnumber.b
       let arr1 = strOne.split('')
       let strTwo = this.logicnumber.c + this.valueThree + this.logicnumber.d
       let arr2 = strTwo.split('') */
      this.formData.outputValue = this.outputValue;
      this.formData.objectSeries = this.form.objectSeries;
      for (let i = 0; i < this.ruleForms.length; i++) {
        let arr = [];
        arr.push(this.ruleForms[i].a);
        arr.push(this.ruleForms[i].valueOne);
        arr.push(this.ruleForms[i].b);
        this.formData.operatorList.push(arr);
      }
      for (let n = 0; n < this.outputValue.length; n++) {
        for (let e = 0; e < this.form.objectSeries.length; e++) {
          if (
            this.outputValue[n].point == this.form.objectSeries[e].countName
          ) {
            this.formData.result.push(this.form.objectSeries[e].id);
            this.formData.writeResultMap[this.form.objectSeries[e].id] =
              this.outputValue[n].value;
          }
        }
      }
      for (let j = 0; j < this.form.objectSeries.length; j++) {
        this.formData.realTimeValue.push(this.form.objectSeries[j].id);
        this.formData.formulaMap[this.form.objectSeries[j].countName] =
          this.form.objectSeries[j].id;
      }
    },
    // 位运算数据赋值 - 基于公式的新逻辑
    bitSelect() {
      this.formData = {
        result: [],
        realTimeValue: [],
        notRealTimeValue: [],
        formulaMap: {},
        formulaValue: [],
        echoMap: {},
        calculationEnum: "BIT",
        status: this.formData.status,
      };
      this.formData.calculateType = "BIT";
      this.formData.objectSeries = this.form.objectSeries;

      // 设置公式
      this.formData.formula = this.form.formula;

      // 解析公式，识别输入变量和输出变量
      const formula = this.form.formula;
      if (formula && formula.includes("=")) {
        const [leftSide, rightSide] = formula.split("=");

        // 左侧是输入变量
        const inputVariables = this.extractVariables(leftSide.trim());
        // 右侧是结果变量
        const resultVariables = this.extractVariables(rightSide.trim());

        // 构建变量映射和分类
        for (let i = 0; i < this.form.objectSeries.length; i++) {
          const variable = this.form.objectSeries[i];
          this.formData.formulaMap[variable.countName] = variable.id;
          this.formData.echoMap[variable.countName] = variable.address;
          // 判断是输入变量还是输出变量
          if (resultVariables.includes(variable.countName)) {
            this.formData.result.push(variable.id);
            if (variable.realTime) {
              this.formData.realTimeValue.push(variable.id);
            } else {
              this.formData.notRealTimeValue.push(variable.id);
            }
          } else if (inputVariables.includes(variable.countName)) {
            this.formData.formulaValue.push(variable.id);
            if (variable.realTime) {
              this.formData.realTimeValue.push(variable.id);
            } else {
              this.formData.notRealTimeValue.push(variable.id);
            }
          }
        }

        console.log("位运算公式解析:", {
          formula: formula,
          inputVariables: inputVariables,
          resultVariables: resultVariables,
          formulaMap: this.formData.formulaMap,
        });
      } else {
        // 如果没有等号 提示
        this.$Message.warning("请输入等号");
        return;
      }
    },

    // 提取字符串中的变量
    extractVariables(str) {
      const variableRegex = /[a-zA-Z][a-zA-Z0-9_]*/g;
      const matches = str.match(variableRegex);
      return matches ? [...new Set(matches.map((v) => v.toLowerCase()))] : [];
    },
    property() {
      if (this.selectList.length !== 1) {
        this.$Message.warning("只能勾选一项");
        return;
      }
      this.visibleProperties = true;
    },
    beforeCloseAdd() {
      this.visibleAdd = false;
      this.visibleAdds = false;
    },
    closeAdd() {
      this.visibleAdd = false;
      this.visibleAdds = false;
    },
    // 清除点位数据
    clearValue() {
      this.description = "";
      this.name = "";
      this.formData.result = [];
      this.formData.realTimeValue = [];
      this.formData.referenceDataPoint = [];
      this.formData.formula = "";
      this.formData.formulaMap = {};
      this.formData.referenceDataPoint = [];
      this.formData.source = "";
      this.formData.delayTime = "";
      this.formData.differenceValue = 0.0;
      this.formData.operatorList = [];
      this.formData.writeResultMap = {};
      Object.keys(this.bitOperationArr).forEach(
        (key) => (this.bitOperationArr[key] = "")
      );
      this.bitOperationValArr = [{ point: "" }];
      this.ruleForms = [{ a: "", b: "", valueOne: "" }];
      this.outputValue = [{ point: "", value: "" }];
    },
    handleConfirmAdd() {
      let _this = this;
      this.$refs.tree.getCheckedNodes(true).forEach((e) => {
        /*_this.form.objectSeries.push(e.data)*/
        console.info(e.data);
        for (let i = 0; i < _this.form.objectSeries.length; i++) {
          if (
            _this.form.objectSeries[i].countName === _this.tableObj.countName
          ) {
            _this.form.objectSeries[i].id = e.data.id;
            _this.form.objectSeries[i].name = e.data.name;
            _this.form.objectSeries[i].type = e.data.type;
            _this.form.objectSeries[i].address = e.data.fullName;
            _this.form.objectSeries[i].realTime = e.data.realTime;
          }
        }
      });
      /*this.form.objectSeries = this.unique(this.form.objectSeries, 'id')*/
      this.visibleAdd = false;
    },
    // 节点被点击时的回调
    treeClick(data) {
      data.data.id;
    },
    handleConfirmAdds() {
      let _this = this;
      let array = _this.$refs.tree.getCheckedNodes(true);
      let id = array[0].data.id;
      if (this.addTitle === "传输目标") {
        service.getRightList(id).then((res) => {
          console.log(res);
          this.tableData = res;
        });
      }
      switch (this.addTitle) {
        case "传输者":
          if (array != null && array.length > 1) {
            this.$Message.warning("最多只能选择一个");
            return;
          }
          this.form.fromObject = array[0].data ? array[0].data : null;
          this.showFromObject = array[0].data.fullName;
          this.formData.source = array[0].data.id;
          this.formData.realTimeValue.push(array[0].data.id);
          break;
        case "传输目标":
          /* if (array != null && array.length > 1) {
            this.$Message.warning('最多只能选择一个')
            return
          } */
          let str = "";
          this.$refs.tree.getCheckedNodes(true).forEach((e) => {
            this.formData.result.push(e.data.id);
            this.formData.realTimeValue.push(e.data.id);
            str += `${e.data.fullName}/`;
          });
          this.form.toObject = array[0].data ? array[0].data : null;
          this.showToObject = str;
          break;
        case "事件触发对象":
          if (array != null && array.length > 1) {
            this.$Message.warning("最多只能选择一个");
            return;
          }
          this.form.triggingObject = array[0].data ? array[0].data : null;
          break;

        default:
          break;
      }
      this.visibleAdds = false;
    },
    addObject(input) {
      this.dataList = [];
      let _this = this;
      this.visibleAdds = true;
      let idm = "";
      this.isEdit ? (idm = this.nodeData.parentId) : (idm = this.nodeData.id);
      if (
        this.nodeData.type == "project" ||
        this.nodeData.type == "server" ||
        this.nodeData.type == "project"
      ) {
        switch (input) {
          case "fromObject":
            this.addTitle = "传输者";
            setTimeout(() => {
              service.getAllTree().then((res) => {
                this.dataList = res;
              });
            }, 1000);
            if (_this.form.fromObject !== null) {
              setTimeout(() => {
                _this.$refs.tree.setChecked(this.form.fromObject.id, true);
              }, 0);
            }

            break;
          case "toObject":
            this.addTitle = "传输目标";
            setTimeout(() => {
              service.getAllTree().then((res) => {
                this.dataList = res;
              });
            }, 1000);
            if (this.form.toObject !== null) {
              setTimeout(() => {
                _this.$refs.tree.setChecked(this.form.toObject.id, true);
              }, 0);
            }
            break;
          default:
            break;
        }
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree("", this.nodeData.id).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          switch (input) {
            case "fromObject":
              _this.addTitle = "传输者";
              setTimeout(() => {
                _this.dataList = res;
              }, 3000);

              break;
            case "toObject":
              _this.addTitle = "传输目标";
              setTimeout(() => {
                _this.dataList = res;
              }, 3000);
              break;
            default:
              break;
          }
        });
      } else if (this.nodeData.type == "calculation") {
        service.getTree("", idm).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          switch (input) {
            case "fromObject":
              _this.addTitle = "传输者";
              setTimeout(() => {
                _this.dataList = res;
              }, 3000);

              break;
            case "toObject":
              _this.addTitle = "传输目标";
              setTimeout(() => {
                _this.dataList = res;
              }, 3000);
              break;
            default:
              break;
          }
        });
      } else {
        switch (input) {
          case "fromObject":
            this.addTitle = "传输者";
            service.getTree("Point", idm).then((res) => {
              if (res[0] !== null) {
                this.dataList = res;
              }
              this.dataList = res;
              console.log(this.dataList);
              if (_this.form.fromObject !== null) {
                setTimeout(() => {
                  _this.$refs.tree.setChecked(this.form.fromObject.id, true);
                }, 0);
              }
            });
            break;
          case "toObject":
            this.addTitle = "传输目标";
            service.getTree("Point", idm).then((res) => {
              if (res[0] !== null) {
                this.dataList = res;
              }
              if (this.form.toObject !== null) {
                setTimeout(() => {
                  _this.$refs.tree.setChecked(this.form.toObject.id, true);
                }, 0);
              }
            });
            break;
          default:
            break;
        }
      }
    },
    unique(arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    beforeCloseProperties() {
      this.visibleProperties = false;
    },
    closeProperties() {
      this.visibleProperties = false;
    },
    handleConfirmProperties() {
      this.visibleProperties = false;
    },
    checkEvent(node, isSelect, halfSelect) {
      if (this.addTitle == "传输者") {
        switch (node.type) {
          case "value_Analog":
            this.singleChoice(node.id);
            break;
          case "value_Multistate":
            this.singleChoice(node.id);
            break;
          case "value_Binary":
            this.singleChoice(node.id);
            break;
          case "value_String":
            this.singleChoice(node.id);
            break;
          case "BinaryInput":
            this.singleChoice(node.id);
            break;
          case "BinaryOutput":
            this.singleChoice(node.id);
            break;
          case "AnalogInput":
            this.singleChoice(node.id);
            break;
          case "AnalogOutput":
            this.singleChoice(node.id);
            break;
          case "boolWrite":
            this.singleChoice(node.id);
            break;
          case "BinaryInputW":
            this.singleChoice(node.id);
            break;
          case "BinaryInputR":
            this.singleChoice(node.id);
            break;
          case "BinaryOutputW":
            this.singleChoice(node.id);
            break;
          case "BinaryOutputR":
            this.singleChoice(node.id);
            break;
          case "AnalogInputW":
            this.singleChoice(node.id);
            break;
          case "AnalogInputR":
            this.singleChoice(node.id);
            break;
          case "AnalogOutputW":
            this.singleChoice(node.id);
            break;
          case "AnalogOutputR":
            this.singleChoice(node.id);
            break;
          case "DigitalOutputW":
            this.singleChoice(node.id);
            break;
          case "DigitalOutputR":
            this.singleChoice(node.id);
            break;
          case "DigitalInputW":
            this.singleChoice(node.id);
            break;
          case "DigitalInputR":
            this.singleChoice(node.id);
            break;
          case "AnalogW":
            this.singleChoice(node.id);
            break;
          case "IntegerW":
            this.singleChoice(node.id);
            break;
          case "AnalogR":
            this.singleChoice(node.id);
            break;
          case "IntegerR":
            this.singleChoice(node.id);
            break;
          case "BinaryW":
            this.singleChoice(node.id);
            break;
          case "BinaryR":
            this.singleChoice(node.id);
            break;
          default:
            this.$Message.error("此节点为目录，无法被选择");
            this.$refs.tree.setChecked(node.id, false);
            break;
        }
      } else {
        this.singleChoice(node.id);
      }
    },
    // 单选操作
    singleChoice(id) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys();
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach((item) => {
          if (item != id) {
            this.$refs.tree.setChecked(item, false);
          }
        });
      }
    },
    selectData(selection, row) {
      this.selectList = selection;
    },
    add(row) {
      this.tableObj = row;
      this.addList = [];
      let _this = this;
      this.visibleAdd = true;
      if (this.nodeData.type == "project" || this.nodeData.type == "server") {
        setTimeout(() => {
          service.getAllTree().then((res) => {
            _this.addList = res;
          });
        }, 1000);
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree("", this.nodeData.id).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          _this.addList = res;
        });
      } else {
        service.getTree("Point", this.nodeData.id).then((res) => {
          this.addList = res;
          if (
            _this.form.objectSeries !== null &&
            _this.form.objectSeries.length > 0
          ) {
            setTimeout(() => {
              /*_this.form.objectSeries.forEach(res => {
                _this.$refs.tree.setChecked(res.id, true)
              })*/
            }, 0);
          }
        });
      }
    },
    del() {
      if (this.selectList === null || this.selectList.length === 0) {
        this.$Message.warning("请至少选择一项");
        return;
      }
      this.selectList.forEach((value, index, array) => {
        this.form.objectSeries = this.form.objectSeries.filter((e) => {
          return e.id !== value.id;
        });
      });
    },
    // 运算数量
    operatingNumber() {
      if (this.formData.calculationEnum === "NUMERICAL") {
        this.formulaFilter(this.form.formula);
      }
      if (this.formData.calculationEnum === "LOGICAL") {
        let arr = [];
        for (let i = 0; i < this.ruleForms.length; i++) {
          arr.push(this.ruleForms[i].a);
          arr.push(this.ruleForms[i].b);
        }
        for (let f = 0; f < this.outputValue.length; f++) {
          arr.push(this.outputValue[f].point);
        }
        let str = arr.toString();
        this.formulaFilter(str);
      }
      if (this.formData.calculationEnum === "BIT") {
        // 位运算使用新的逻辑处理公式
        this.processBitFormula(this.form.formula);
      }
    },

    // 位运算公式处理 - 专门处理位运算逻辑
    processBitFormula(formula) {
      if (!formula) {
        this.form.objectSeries.length = 0;
        return;
      }

      console.log("位运算公式处理:", formula);

      // 清空现有的对象系列
      this.form.objectSeries.length = 0;

      // 提取公式中的变量（支持多字符变量名）
      const variableRegex = /[a-zA-Z][a-zA-Z0-9_]*/g;
      const matches = formula.match(variableRegex);

      if (matches) {
        // 去重并转换为小写
        const variables = [...new Set(matches.map((v) => v.toLowerCase()))];

        // 为每个变量创建对象
        variables.forEach((variable) => {
          const obj = {
            name: "",
            type: "",
            countName: variable,
            id: "",
            address: "",
          };
          this.form.objectSeries.push(obj);
        });

        console.log("位运算识别到的变量:", variables);
        console.log("更新后的objectSeries:", this.form.objectSeries);
      }

      // 可以在这里添加更多位运算特定的逻辑
      // 例如：验证公式语法、识别运算符类型等
      this.validateBitFormula(formula);
    },

    // 提交时验证位运算公式 - 返回验证结果
    validateBitFormulaForSubmit() {
      const formula = this.form.formula;

      // 检查公式是否为空
      if (!formula || formula.trim() === "") {
        this.$Message.warning("请输入位运算公式");
        return false;
      }

      // 检查是否包含等号
      const equalSigns = (formula.match(/=/g) || []).length;
      if (equalSigns === 0) {
        this.$Message.warning("位运算公式必须包含等号，格式如：a&b=c");
        return false;
      }

      if (equalSigns > 1) {
        this.$Message.warning("位运算公式只能包含一个等号");
        return false;
      }

      // 检查是否包含位运算符
      const bitOperators = ["&", "|", "^", "!", "~", "@", "#", "$"];
      const hasValidOperators = bitOperators.some((op) => formula.includes(op));

      if (!hasValidOperators) {
        this.$Message.warning(
          "位运算公式必须包含位运算符：&（与）、|（或）、!（非）、#（与非）、@（或非）、~（同或）、$（异或）"
        );
        return false;
      }

      // 检查括号匹配
      const openBrackets = (formula.match(/\(/g) || []).length;
      const closeBrackets = (formula.match(/\)/g) || []).length;

      if (openBrackets !== closeBrackets) {
        this.$Message.warning("位运算公式括号不匹配，请检查括号数量");
        return false;
      }

      // 检查是否包含变量
      const variableRegex = /[a-zA-Z][a-zA-Z0-9_]*/g;
      const matches = formula.match(variableRegex);

      if (!matches || matches.length < 2) {
        this.$Message.warning("位运算公式至少需要包含2个变量");
        return false;
      }

      // 检查等号两侧是否都有内容
      const [leftSide, rightSide] = formula.split("=");

      if (!leftSide.trim()) {
        this.$Message.warning("等号左侧不能为空");
        return false;
      }

      if (!rightSide.trim()) {
        this.$Message.warning("等号右侧不能为空");
        return false;
      }

      // 检查右侧是否只有一个变量（结果变量）
      const rightVariables = rightSide.trim().match(variableRegex);
      if (!rightVariables || rightVariables.length !== 1) {
        this.$Message.warning("等号右侧只能有一个结果变量");
        return false;
      }

      console.log("位运算公式验证通过:", formula);
      return true;
    },

    // 验证位运算公式的语法
    validateBitFormula(formula) {
      // 检查基本的位运算符
      const bitOperators = ["&", "|", "^", "!", "~", "@", "#", "$"];
      const hasValidOperators = bitOperators.some((op) => formula.includes(op));

      if (!hasValidOperators && formula.includes("=")) {
        console.warn("位运算公式可能缺少位运算符");
      }

      // 检查括号匹配
      const openBrackets = (formula.match(/\(/g) || []).length;
      const closeBrackets = (formula.match(/\)/g) || []).length;

      if (openBrackets !== closeBrackets) {
        console.warn("位运算公式括号不匹配");
      }

      // 检查等号
      const equalSigns = (formula.match(/=/g) || []).length;
      if (equalSigns > 1) {
        console.warn("位运算公式包含多个等号");
      } else if (equalSigns === 0) {
        console.warn("位运算公式缺少等号，可能只是表达式");
      }

      console.log("位运算公式验证完成:", {
        formula: formula,
        hasValidOperators: hasValidOperators,
        bracketsMatch: openBrackets === closeBrackets,
        equalSigns: equalSigns,
      });
    },

    // 公式过滤
    formulaFilter(String) {
      this.form.objectSeries.length = 0;
      let EngString = String.replace(/[^a-z]+/gi, ""); // 提取字符串中的英文字符
      let minEngString = EngString.toLowerCase(); // 将大写的英文字符转化为小写的
      let engArray = minEngString.split(""); // 将字符串转化为数组
      // 去重操作
      let newEngSet = new Set(engArray);
      let newEngArray = Array.from(newEngSet);
      // 遍历英文字符转数组并加载对应的表格点位数量
      for (let i = 0; i < newEngArray.length; i++) {
        let obj = {
          name: "",
          type: "",
          countName: "",
          id: "",
          address: "",
        };
        obj.countName = newEngArray[i];
        this.form.objectSeries.push(obj); // 像表格中插入对应的数据框
      }
    },
    modalHelp() {},
    handleCloseHelp() {
      this.dialogHelp = false;
    },
    timestampToYMDHMS(timestamp) {
      const date = new Date(timestamp);
      const year = date.getUTCFullYear();
      const month = ("0" + (date.getUTCMonth() + 1)).slice(-2); // 月份是从0开始的
      const day = ("0" + date.getUTCDate()).slice(-2);
      const hours = ("0" + date.getUTCHours()).slice(-2);
      const minutes = ("0" + date.getUTCMinutes()).slice(-2);
      const seconds = ("0" + date.getUTCSeconds()).slice(-2);
      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>
<style scoped>
.content-main {
  width: 100%;
  height: 300px;
}

.content-tab {
  width: 100%;
  height: 100%;
  margin-top: 5px;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 200px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #4444449f;
  border-radius: 1px;
}

.button {
  margin-top: 20%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/notebook/countbook.vue